import React, { useState, useEffect } from 'react'
import CookiesPopover from 'ui/modules/popover/cookiesPopover'
import { setAcceptCookies, getAreCookiesAccepted } from 'services/cookies'
import { initGA } from '../libs/ga'
import { initHotjar } from '../libs/hotjar'

const CookieAdvice = () => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClose = () => setIsOpen(false)

  const handleAccept = () => {
    setAcceptCookies(true)
    setIsOpen(false)
    initGA()
    initHotjar()
  }

  useEffect(() => {
    if (!getAreCookiesAccepted()) setIsOpen(true)
  }, [])

  return (
    <CookiesPopover
      open={isOpen}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      onClose={handleClose}
      onAccept={handleAccept}
      onReject={handleClose}
    />
  )
}

export default CookieAdvice
